// HACK: overrides href behavior of NavItem and mashes up with NavLink
// see: https://github.com/ReactTraining/react-router/issues/446
// see: https://github.com/react-bootstrap/react-router-bootstrap/issues/18

import React from 'react';
import { Route } from 'react-router';
import { NavItem } from 'react-bootstrap';

export default (
  {
    to,
    exact,
    strict,
    isActive,
    ...rest
  }
) => (
  <Route
    path={typeof to === 'object' ? to.pathname : to}
    exact={exact}
    strict={strict}
    children={({ location, match, history }) => {
      const active = !!(isActive ? isActive(match, location) : match);
      return (
        <NavItem
          {...rest}
          href={to}
          onClick={e => {
            e.preventDefault();
            history.push(to);
          }}
          active={active}
        />
      );
    }}
  />
);



// WEBPACK FOOTER //
// ./src/components/ui/NavItemLink.js